import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import FormData from "form-data";
import "../css/ParentForm.css";
import DescriptionIcon from "@material-ui/icons/Description";
import moment from "moment";
import Loader from "../../common/Loader";
import { DecryptED } from "../../DecryptJS/Decrypt";

const ParentForm = () => {
  const defaultUrl = "https://commonfiles.prisms.in/commonfiles/avatar.jpg";
  const baseUrl = "https://marcopolo.prisms.in/api/information";

  const [schoolName, setSchoolName] = useState("");
  const [Loading, setLoading] = useState(false);
  const [acadYear, setAcadYear] = useState("");
  // const [image, setImage] = useState(null);
  const [studentValues, setSvalues] = useState([]);
  const [isEmpty, setIsEmpty] = useState();
  const [studentVariables, setSvariables] = useState([]);
  const [tablename, setTablename] = useState("");
  const [inputNature, setInputNature] = useState("");
  const [txtTitle, settxtTitle] = useState("");
  const [txtTitle2, settxtTitle2] = useState("");
  const [state, setState] = useState({});
  const { sid, userid } = useParams();
  const [response, setResponse] = useState("");
  const [keyArr, setKeyArr] = useState([]);
  const [valueArr, setValueArr] = useState([]);
  const [storeValueArr, setStoreValueArr] = useState([]);
  const [render, setRender] = useState(false);
  const [attachmentsFile, setAttachment] = useState("");
  const [imageInfo, setImageInfo] = useState({
    file: [],
    filepreview: null,
  });

  const handleImageChange = (event) => {
    let reader = new FileReader();
    const imageFile = event.target.files[0];
    const imageFilname = event.target.files[0].name;

    reader.onload = (e) => {
      const img = new Image();
      img.onload = () => {
        //------------- Resize img code ----------------------------------
        var canvas = document.createElement("canvas");
        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        var MAX_WIDTH = 700;
        var MAX_HEIGHT = 700;
        var width = img.width;
        var height = img.height;

        if (width > height) {
          if (width > MAX_WIDTH) {
            height *= MAX_WIDTH / width;
            width = MAX_WIDTH;
          }
        } else {
          if (height > MAX_HEIGHT) {
            width *= MAX_HEIGHT / height;
            height = MAX_HEIGHT;
          }
        }
        canvas.width = width;
        canvas.height = height;
        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, width, height);
        ctx.canvas.toBlob(
          (blob) => {
            const file = new File([blob], imageFilname, {
              type: "image/jpeg",
              lastModified: Date.now(),
            });
            setImageInfo({
              ...imageInfo,
              file: file,
              filepreview: URL.createObjectURL(imageFile),
            });
          },
          "image/jpeg",
          1
        );
      };
      //debugger
      img.src = e.target.result;
    };
    reader.readAsDataURL(imageFile);
  };

  // const handleImageChange = async (e) => {
  //   if (e.target.files[0]) {
  //     setImage(e.target.files[0]);
  //   }
  // };

  const handleFile = (e) => {
    setAttachment(e.target.files[0]);
  };
  const handleFileSubmit = async (e, file) => {
    e.preventDefault();
    let bucketName = `topschool-attachments/${schoolName}prisms/${acadYear}/parentUpload/${file.toLowerCase()}`;
    let formData = new FormData();
    formData.append("sid", DecryptED(sid));
    formData.append("user_id", DecryptED(userid));
    formData.append("tablename", tablename);
    formData.append("bucketName", bucketName);
    formData.append("profile", `${file.toLowerCase()}`);
    // formData.append("image", image);
    formData.append("image", attachmentsFile);
    await axios({
      method: "POST",
      url: `${baseUrl}/changepic`,
      data: formData,
      headers: {
        Authorization: "#$laksdfnlknoea#$@$%^&%$",
        "Content-Type": "multipart/form-data",
        "Access-Control-Allow-Origin": "*",
      },
    })
      .then((response) => {
        Swal.fire({
          position: "center",
          icon: "success",
          title: `Image updated successfully!`,
          showConfirmButton: false,
          timer: 1500,
        });
        // window.location.reload();
        setRender(!render);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong",
        });
      });
  };
  const handleImageSubmit = async (e, pictype) => {
    e.preventDefault();
    let bucketName = `topschool-attachments/${schoolName}prisms/${acadYear}/parentUpload/${pictype.toLowerCase()}picture`;
    let formData = new FormData();
    formData.append("sid",  DecryptED(sid));
    formData.append("user_id", DecryptED(userid));
    formData.append("tablename", tablename);
    formData.append("bucketName", bucketName);
    formData.append("profile", `${pictype.toLowerCase()}`);
    // formData.append("image", image);
    formData.append("image", imageInfo.file);
    await axios({
      method: "POST",
      url: `${baseUrl}/changepic`,
      data: formData,
      headers: {
        Authorization: "#$laksdfnlknoea#$@$%^&%$",
        "Content-Type": "multipart/form-data",
        "Access-Control-Allow-Origin": "*",
      },
    })
      .then((response) => {
        Swal.fire({
          position: "center",
          icon: "success",
          title: `Image updated successfully!`,
          showConfirmButton: false,
          timer: 1500,
        });
        // window.location.reload();
        setRender(!render);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong",
        });
      });
  };
  const handleChange = (e, idx) => {
    let key = keyArr[idx];
    let value = e.target.value;

    setStoreValueArr((state) => ({
      ...state,
      [idx]: value,
    }));

    setState((state) => ({
      ...state,
      [key]: value,
    }));
  };
  // console.log(state);
  // console.log(storeValueArr)

  const updateData = async (e) => {
    const data = {
      sid :  DecryptED(sid),
      user_id: DecryptED(userid),
      tablename,
      columns: state,
    };
    await axios({
      method: "POST",
      url: `${baseUrl}/update`,
      data,
      headers: {
        Authorization: "#$laksdfnlknoea#$@$%^&%$",
      },
    })
      .then((response) => {
        Swal.fire({
          position: "center",
          icon: "success",
          title: `Form updated successfully!`,
          showConfirmButton: false,
          timer: 1500,
        });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong",
        });
      });
  };
  useEffect(() => {
    const getSchoolName = async () => {
      const data = {
        fun_name: "getSchoolURL",
        sid : DecryptED(sid)
      };
      await axios({
        method: "POST",
        url: "https://topschool.prisms.in/rest/index.php/user_list.json",
        data,
      }).then((response) => {
        setSchoolName(response.data);
      });
    };
    getSchoolName();
    const getAcadId = async () => {
      const data = {
        sid: DecryptED(sid)
      };
      await axios({
        method: "POST",
        url: "https://marcopolo.prisms.in/api/tscommon/getCurrentAcad",
        data,
        headers: {
          Authorization: "#$laksdfnlknoea#$@$%^&%$",
        },
      }).then(async (response) => {
        setAcadYear(response.data[0].academics);
      });
    };
    getAcadId();
    const getData = async () => {
      const data = {
        sid: DecryptED(sid)
      };
      await axios({
        method: "POST",
        url: `${baseUrl}/fields`,
        data,
        headers: {
          Authorization: "#$laksdfnlknoea#$@$%^&%$",
        },
      }).then(async (response) => {
        if (response.data[0].values !== "") {
          setIsEmpty(response.data[0].values);

          setTablename(response.data[0].variables);
          let keys = [];
          let values = [];
          let natures = [];
          let title = [];
          setResponse(response.data[0].values);
          const string = response.data[0].values;

          // check for if the multiple tables is there
          if (response.data.length > 1) {
            const tv2 = response.data[1].values;
            setSvalues(tv2);
            let txttitle2 = [];

            tv2
              .split("|")[3]
              .split(",")
              .map((data) => {
                txttitle2.push(data);
              });
            settxtTitle2(txttitle2);
            const tvv2 = response.data[1].variables
              ? response.data[1].variables
              : "";
            setSvariables(tvv2);
          } else {
            console.log("Data not available");
          }

          string
            .split("|")[0]
            .split(",")
            .map((key) => {
              keys.push(key);
            });
          setKeyArr(keys);
          string
            .split("|")[1]
            .split(",")
            .map((value) => {
              values.push(value);
            });
          setValueArr(values);
          string
            .split("|")[2]
            .split(",")
            .map((nature) => {
              natures.push(nature);
            });
          setInputNature(natures);
          string
            .split("|")[3]
            .split(",")
            .map((data) => {
              title.push(data);
            });
          settxtTitle(title);

          const data = {
            sid : DecryptED(sid),
            user_id: DecryptED(userid),
            tablename: response.data[0].variables,
            data: keys,
          };
          setLoading(true);

          const result = await axios({
            method: "POST",
            url: `${baseUrl}/data`,
            data,
            headers: {
              Authorization: "#$laksdfnlknoea#$@$%^&%$",
            },
          });
          if (result) {
            console.log(Object.values(result.data[0]));
            setStoreValueArr(Object.values(result.data[0]));
            setLoading(false);
          }
        }
      });
    };
    getData();
  }, [render]);

  return (
    <div className="mainDiv">
      <div className="mtables">
        {txtTitle ? (
          <Link to={`/parentForm/${sid}/${userid}`} className="next_subheading">
            {txtTitle}
          </Link>
        ) : null}
        {txtTitle2 ? (
          <Link
            to={{
              pathname: `/studentinfo/${sid}/${userid}`,
              state: {
                studentValues,
                studentVariables,
                schoolName,
                acadYear,
                txtTitle,
                txtTitle2,
              },
            }}
            className="next_subheading"
          >
            {txtTitle2}
          </Link>
        ) : null}
      </div>
      {Loading ? (
        <Loader />
      ) : (
        valueArr.map((value, idx) => {
          if (inputNature[idx] === "text") {
            return (
              <div className="resultDiv" key={idx}>
                <div className="labelDiv">
                  <label className="labelStyle" htmlFor={keyArr[idx]}>
                    {value}
                  </label>
                </div>
                {console.log(idx)}
                <div className="inputDiv">
                  <textarea
                    className="inputStyle"
                    value={storeValueArr[idx]}
                    name={keyArr[idx]}
                    onChange={(e) => handleChange(e, idx)}
                  />
                </div>
              </div>
            );
          } else if (inputNature[idx] === "date") {
            return (
              <div className="resultDiv" key={idx}>
                <div className="labelDiv">
                  <label className="labelStyle" htmlFor={keyArr[idx]}>
                    {value}
                  </label>
                </div>
                {console.log(idx)}
                <div className="inputDiv">
                  <input
                    type="date"
                    className="inputStyle__type__date "
                    value={moment(storeValueArr[idx]).format("YYYY-MM-DD")}
                    name={keyArr[idx]}
                    onChange={(e) => handleChange(e, idx)}
                  />
                </div>
              </div>
            );
          } else if (inputNature[idx] === "img") {
            console.log(value);
            return (
              <div className="resultImageDiv" key={idx}>
                <div className="labelDiv">
                  <label className="labelStyle" htmlFor={keyArr[idx]}>
                    {value}
                  </label>
                </div>
                <div className="inputDiv">
                  <img
                    className="inputImageStyle"
                    src={storeValueArr[idx] ? storeValueArr[idx] : defaultUrl}
                    //src={storeValueArr[idx]}
                    alt="profilePhoto"
                    // alt={storeValueArr[idx]}
                  />
                  <div className="uploadDiv">
                    <form
                      className="input__form"
                      onSubmit={(e) => handleImageSubmit(e, keyArr[idx])}
                    >
                      <input
                        className="uploadInputStyle"
                        type="file"
                        name="filename"
                        id="myFile"
                        onChange={(e) => handleImageChange(e)}
                      />
                      <input
                        // onClick={(e) => handleImageSubmit(e, value.split(" ")[0])}
                        value="Upload"
                        className="uploadBtn"
                        type="submit"
                      />
                    </form>
                  </div>
                </div>
              </div>
            );
          } else if (inputNature[idx] === "info") {
            console.log("something went wrong here");
            return (
              <div style={{ textAlign: "start", margin: "5px 0" }}>
                <div>
                  <a
                    className="link__tag"
                    target="_blank"
                    href={value.match(/<a\s+(?:[^>]*?\s+)?href="([^"]*)"/)[1]}
                    id="myid"
                  >
                    {value.replace(/<\/?a[^>]*>/g, "")}
                  </a>
                </div>
              </div>
            );
          } else if (inputNature[idx] === "file") {
            console.log(value);
            return (
              <div className="resultImageDiv" key={idx}>
                <div className="labelDiv">
                  <label className="labelStyle" htmlFor={keyArr[idx]}>
                    {value}
                  </label>
                </div>
                <div className="inputDiv">
                  <DescriptionIcon
                    style={{
                      width: "126px",
                      height: "115px",
                      color: "rgb(84, 26, 220)",
                    }}
                  />
                  {/* <img
                  className="inputImageStyle"
                  src={"data:image/png;base64,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"}
                  //src={storeValueArr[idx]}
                  alt="attachment"
                  // alt={storeValueArr[idx]}
                /> */}
                  <div className="uploadDiv">
                    <form
                      className="input__form"
                      onSubmit={(e) => handleFileSubmit(e, keyArr[idx])}
                    >
                      <input
                        className="uploadInputStyle"
                        type="file"
                        name="filename"
                        id="myFile"
                        onChange={(e) => handleFile(e)}
                      />
                      <input
                        // onClick={(e) => handleImageSubmit(e, value.split(" ")[0])}
                        value="Upload"
                        className="uploadBtn"
                        type="submit"
                      />
                    </form>
                  </div>
                </div>
              </div>
            );
          }
        })
      )}

      {txtTitle ? (
        <div className="buttonDiv">
          <button className="button" onClick={(e) => updateData(e)}>
            Update
          </button>
        </div>
      ) : (
        <p
          style={{
            fontFamily: "monospace",
            color: "blue",
            marginTop: "10px",
            fontSize: "16px",
          }}
        >
          Information is not required to be updated at the moment.
        </p>
      )}
    </div>
  );
};

export default ParentForm;
